import { mapToEcommerceItem, } from '@pegasus/tracker';
import { tracker } from '../track';
export const trackSelectPromotion = (payload, options) => {
    var _a, _b;
    try {
        const { creativeName, element, itemListName, item, creativeSlot } = payload;
        tracker.track('GA4-EEC-select_promotion', {
            event_name: 'select_promotion',
            select_promotion: {
                element: element || null,
                creative_name: creativeName || null,
                creative_slot: creativeSlot !== null && creativeSlot !== void 0 ? creativeSlot : null,
                promotion_id: item.campaignIdentifier || null,
                promotion_name: null,
                items: [
                    mapToEcommerceItem(Object.assign({ affiliation: item.categoryId || null, early_access_item: item.earlyAccessItem || false, index: (_a = item.index) !== null && _a !== void 0 ? _a : 0, item_list_name: itemListName, promotion_id: item.campaignIdentifier, plus_exclusive: (item === null || item === void 0 ? void 0 : item.isExclusiveItem) || false }, (_b = options === null || options === void 0 ? void 0 : options.customMapper) === null || _b === void 0 ? void 0 : _b.call(options, item))),
                ],
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `select_promotion` failed.', e);
    }
};
